export const App = window.App || {};
